import { prop } from 'ramda';

export const getAppointment = prop('appointment');
